<div class="container-fluid px-5">
  <div class="text-center mb-4">
    <img src="/assets/app/img/brand-logo.png" height="48" alt="Zscaler" />
  </div>
  <div class="card bg-light">
    <div class="card-body py-5">
      <div class="row justify-content-center">
        <div class="col-md-8 text-center">
          <h4 class="card-title">
            Important Notice: Browser Isolation Administrative Interface
            Deprecation
          </h4>
          <p class="card-text">
            We are pleased to announce that we have migrated all the browser
            isolation related administrative capabilities (Profiles, Banners,
            Certificates etc) to the Zscaler Internet Access (ZIA) and Zscaler
            Private Access(ZPA) administrative user interfaces for a better
            administrative experience. As a result, we will be deprecating our
            old administrative interface.
          </p>
          <p class="card-text">
            ZIA Isolation profiles can now be created by logging in to the
            <a
              href="https://help.zscaler.com/zia/accessing-and-navigating-zia-admin-portal"
            >
              ZIA Administrative Interface
            </a>
            and navigating to Administration -> Secure Browsing -> Browser
            Isolation. Additional documentation refers to the help
            <a
              href="https://help.zscaler.com/isolation/creating-zia-isolation-profile-isolation"
            >
              article
            </a>
            on our help portal.
          </p>
          <p class="card-text">
            ZPA Isolation profiles can now be created by logging in to the
            <!-- this link needs to be updated -->
            <a
              href="https://help.zscaler.com/zpa/accessing-and-navigating-zpa-admin-portal"
            >
              ZPA Administrative Interface
            </a>
            and navigating to Configuration & Control -> Browser Isolation ->
            Isolation Profiles. Additional documentation refers to the help
            <a
              href="https://help.zscaler.com/isolation/creating-isolation-profiles-zpa"
            >
              article
            </a>
            on our help portal.
          </p>
          <p class="card-text">
            If you have any questions or need assistance with the transition,
            please don't hesitate to contact our support team. We are always
            here to help. <br />
            Thank you for your continued support and for choosing Zscaler.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
